module.exports = {"title":"Enviamos um código para você.","description":"Para fazer o bloqueio, coloque aqui o código que a gente enviou para o celular final (00) xxxxx-xx00.","label":"código","placeholder":"Ex 0000000"}


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/TokenModal/data.json
// module id = 2297
// module chunks = 0